import { Box, Typography, CircularProgress } from "@mui/material";
import NoRecords from "components/NoRecords";
import { BasePathProvider, useBasePath } from "components/Providers";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import OtherAbsentStaffList from "./List/OtherAbsentStaffList";
import { InfoOutlined } from "@mui/icons-material";

const OtherAbsentStaff = ({ otherAbsentStaff, boxStyles, innerBoxStyles }) => {
    const baseUrl = useBasePath();
    const loading = useSelector(state => state.substitutePortal.substitute.loading);
    const { t } = useTranslation();

    return (
        <BasePathProvider value={`${baseUrl}`}>
            <Box sx={{ ...boxStyles, flexGrow: 1 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle1">{t('Other Absent Staff')}</Typography>
                </Box>
                {loading ? (
                    <Box sx={{ ...innerBoxStyles }}>
                        <CircularProgress size={50} />
                    </Box>
                ) : otherAbsentStaff?.length > 0 ? (
                    <Box sx={{ ...innerBoxStyles, alignItems: "flex-start" }}>
                        <OtherAbsentStaffList otherAbsentStaff={otherAbsentStaff} />
                    </Box>
                ) : (
                    <Box sx={{ ...innerBoxStyles, mt: 0 }}>
                        <NoRecords
                            icon={<InfoOutlined sx={{ fontSize: 50, color: "primary.main" }} />}
                            message={t("No Other Staff Absent")}
                        />
                    </Box>
                )}
            </Box>
        </BasePathProvider>
    );
};

export default OtherAbsentStaff;